import { Box, Collapse, Typography } from "@mui/material";
import type { Icon } from "@phosphor-icons/react";
import {
  CaretDown,
  CaretRight,
  Folder as FolderIcon,
} from "@phosphor-icons/react";
import React, { useState } from "react";
import { useDataSidebarContext } from "./context";

interface CollapsibleFolderGroupProps {
  title: string;
  defaultExpanded?: boolean;
  icon?: Icon;
  children: React.ReactNode;
}

export const CollapsibleFolderGroup: React.FC<CollapsibleFolderGroupProps> = ({
  title,
  defaultExpanded = true,
  icon,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultExpanded);
  const { isDarkMode, palette } = useDataSidebarContext();
  const textColor = isDarkMode ? palette.gray[300] : palette.gray[600];
  const IconComponent = icon ?? FolderIcon;

  return (
    <Box>
      <Box
        onClick={() => setIsOpen(!isOpen)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "4px 8px",
          cursor: "pointer",
          borderRadius: "4px",
          "&:hover": {
            backgroundColor: isDarkMode ? palette.gray[800] : palette.blue[50],
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flex: 1,
            minWidth: 0,
          }}
        >
          <IconComponent size={16} color={textColor} />
          <Typography
            sx={{
              color: textColor,
              fontFamily: "Roboto",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "20px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              minWidth: 0,
              flex: 1,
            }}
          >
            {title}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", color: textColor }}>
          {isOpen ? <CaretDown size={16} /> : <CaretRight size={16} />}
        </Box>
      </Box>
      <Collapse in={isOpen}>
        <Box sx={{ marginLeft: "8px" }}>{children}</Box>
      </Collapse>
    </Box>
  );
};
